import React from "react";
export var View = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.compact, compact = _c === void 0 ? false : _c;
    return React.createElement("main", { className: className + " flex-grow relative " + (compact ? "" : "mt-8") }, children);
};
//# sourceMappingURL=View.js.map